import dynamic from 'next/dynamic';

/**
 * NextJs Dynamic Import based on route - https://nextjs.org/docs/advanced-features/dynamic-import
 * @type {React.ComponentType<{}>}
 */
export const Account = dynamic(() => import('app/routes/account/account'));
export const Auth = dynamic(() => import('app/routes/auth'));
export const Start = dynamic(() => import('app/routes/start'));
export const Triage = dynamic(() => import('app/routes/start/Triage'));
export const Visit = dynamic(() => import('app/routes/visit/visit'));
export const Coupon = dynamic(() => import('app/routes/coupon/CouponPage'));
export const Chat = dynamic(() => import('app/routes/gold/chat'));
export const GoldDrugInformation = dynamic(() => import('app/routes/gold/goldDrugInformation'));
export const Service = dynamic(() => import('app/routes/gold/service'));
export const DrugInformation = dynamic(() => import('app/routes/drug-information/DrugInformation'));
export const Education = dynamic(() => import('app/routes/education/Education'));
